import { Typography, useTheme } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { anonymizeAccountDetails } from '../../utils/anonymizeAccountDetails/anonymizeAccountDetails';

import type { MaskedIbanProps } from './MaskedIban.types';

export function MaskedIban({ iban, ariaLabel }: MaskedIbanProps) {
  const { tokens } = useTheme();

  const { anonymizedIban, prefix, suffix } = anonymizeIban(iban);

  return (
    <>
      <Typography
        aria-describedby="iban-mask-info"
        color={tokens.bankCardValueSupport}
        variant="body3"
      >
        <span aria-hidden>{anonymizedIban}</span>
      </Typography>
      <span id="iban-mask-info" style={visuallyHidden}>
        {ariaLabel({ prefix, suffix })}
      </span>
    </>
  );
}

export const anonymizeIban = (iban: string) => {
  const anonymizedIban = anonymizeAccountDetails(iban);

  const prefix = anonymizedIban.slice(0, anonymizedIban.indexOf('•'));
  const suffix = anonymizedIban.slice(anonymizedIban.lastIndexOf('•') + 1);

  return { anonymizedIban, prefix, suffix };
};
